import type { RewardCurrency } from "../../shared/models";

/** Stars are whole numbers; dollars are stored as cents. */
export function formatReward(amount: number, currency: RewardCurrency, opts: { sign?: boolean } = {}): string {
  const sign = opts.sign && amount > 0 ? "+" : amount < 0 ? "−" : "";
  const abs = Math.abs(amount);
  if (currency === "dollars") return `${sign}$${(abs / 100).toFixed(abs % 100 === 0 ? 0 : 2)}`;
  return `${sign}${abs} ★`;
}

/** Parse an amount typed by an adult ("2.50" dollars or "5" stars) into stored units. */
export function parseReward(text: string, currency: RewardCurrency): number | null {
  const n = Number(text.replace(/[$★\s]/g, ""));
  if (!Number.isFinite(n) || n < 0) return null;
  return currency === "dollars" ? Math.round(n * 100) : Math.round(n);
}
